<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import HeadingSecondary from '@/components/general/HeadingSecondary.vue';
import DateTimePicker from '@/components/general/DateTimePicker.vue';
import TipTap from '@/components/annotations/TipTap.vue';
import { useState, useGetters } from '@/composables/useVuexHelpers';

const dateTimeInputEnabled = ref(false);
const respondTimeOptions = ref([
  { label: '4 Hours', value: 4 },
  { label: '1 Day', value: 24 },
  { label: '2 Days', value: 48 },
  { label: '3 Days', value: 72 },
  { label: '1 Week', value: 168 },
]);

const { generalInstructions } = useState(['generalInstructions']);
const { permissionLevel } = useGetters(['permissionLevel']);

onMounted(() => {
  dateTimeInputEnabled.value = generalInstructions.value.timeframeEnabled;
});

watch(dateTimeInputEnabled, value => {
  if (generalInstructions.value?.timeframes?.length) {
    generalInstructions.value.timeframes.at(-1).enabled = value;
  }
});
</script>

<template>
  <div>
    <HeadingSecondary title="General Instructions" :small="true" />

    <div class="uk-flex uk-flex-top uk-margin-bottom uk-width-1-1">
      <div v-if="permissionLevel === PermissionLevel.COHORT" class="uk-text-muted">
        <span v-if="generalInstructions?.instructions?.replaceAll(/<[/]?p>/g, '')?.trim() === ''">
          No General Team Instructions at this time.
        </span>
        <span v-else v-html="generalInstructions.instructions"> </span>
      </div>
      <TipTap
        v-else
        class="tip-tap-text-area uk-width-1-1 uk-text-left"
        v-model="generalInstructions.instructions"
        placeholder="Clearly state any rules for your team..."
        :max-characters="280"
        :disabled="permissionLevel === PermissionLevel.COHORT"
      />
    </div>

    <div
      v-if="
        generalInstructions.timeframes &&
        (generalInstructions.timeframeEnabled || permissionLevel !== PermissionLevel.COHORT)
      "
      class="uk-flex uk-flex-bottom uk-margin-top uk-margin-bottom uk-width-1-1"
    >
      <div class="uk-width-1-1">
        <label
          v-if="permissionLevel !== PermissionLevel.COHORT"
          for="enable"
          class="uk-text-small"
          uk-tooltip="Uncheck to disable the use of a Due Date for the replies of your Team Members"
        >
          <input
            type="checkbox"
            class="uk-checkbox"
            name="enable"
            id="enable"
            v-model="dateTimeInputEnabled"
          />
          Set a Due Date for Team Member Replies
        </label>
        <div class="uk-flex uk-flex-middle uk-margin-small-top" v-if="dateTimeInputEnabled">
          <DateTimePicker
            :label="permissionLevel === PermissionLevel.COHORT ? 'Due Date:' : 'Due By:'"
            :respondTimeOptions="respondTimeOptions"
            :defaultTime="generalInstructions?.timeframes?.at(-1)?.updatedAt"
            :defaultTimeThreshold="
              parseFloat(generalInstructions?.timeframes?.at(-1)?.timeframeThreshold)
            "
            :disabled="!dateTimeInputEnabled || permissionLevel === PermissionLevel.COHORT"
            @timeThresholdChange="generalInstructions.timeframes.at(-1).timeframeThreshold = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#dueDateHistoryPanel {
  &::before {
    right: 3rem;
  }
}
</style>
